<div class="myc-lang-modal">
    <header class="myc-lang-modal__header">
        <h2 class="myc-lang-modal__title">{{ 'aumico_pdf_my_language_modal_title' | i18next }}</h2>
        <p class="myc-lang-modal__subtitle">{{ 'aumico_pdf_my_language_modal_subtitle' | i18next }}</p>
    </header>

    <div class="myc-lang-modal__body">
        <ul class="myc-lang-modal__list">
            <li
                *ngFor="let entry of data.availableLanguages"
                class="myc-lang-modal__row"
                [class.myc-lang-modal__row--selected]="isSelected(entry.lang)"
                (click)="onSelect(entry.lang)"
            >
                <!--
                    Custom-checkbox visual — same `.custom-checkbox` styling
                    as the language-switch dropdown + user-filter-drop-down
                    (teal background + white check). Single-select semantics
                    are enforced in the TS (`onSelect` replaces the value,
                    doesn't toggle a set). The wrapping `<li>` carries the
                    click handler; `tabindex="-1"` keeps keyboard focus on
                    the row instead of jumping to each input.
                -->
                <input
                    type="checkbox"
                    class="myc-lang-modal__radio"
                    [checked]="isSelected(entry.lang)"
                    tabindex="-1"
                    (click)="$event.stopPropagation(); onSelect(entry.lang)"
                />
                <span class="myc-lang-modal__label">
                    {{ localeI18nKey(entry.lang) | i18next: { defaultValue: entry.lang } }}
                </span>
                <span class="myc-lang-modal__count">
                    {{ entry.count }}
                    {{
                        (entry.count === 1
                            ? 'aumico_pdf_my_language_modal_count_singular'
                            : 'aumico_pdf_my_language_modal_count_plural'
                        ) | i18next
                    }}
                </span>
            </li>
        </ul>
    </div>

    <footer class="myc-lang-modal__footer">
        <!--
            No Cancel button: the container opens this dialog with
            `disableClose: true` because the multi-year comparison cannot
            be rendered without a single locale committed. Forcing a pick
            is the cleanest way to guarantee the page never lands in a
            "no data + no error + no pending" zombie state.
        -->
        <ham-button variant="primary" [disabled]="confirmDisabled" (buttonClick)="onConfirm()">
            {{ 'aumico_pdf_my_language_modal_confirm' | i18next }}
        </ham-button>
    </footer>
</div>
